export const selectInvalidateNavConfigStatus = state => {
  return state.invalidateNavConfig.status;
};